<div class="position-relative custom-search-container">
  <div role="search" class="custom-search clearfix">
    <input
      #searchInput
      [placeholder]="configuration?.placeholder || ''"
      autocomplete="off"
      type="text"
      class="form-control searchTerm"
      (input)="searchSuggest($event)"
      [value]="inputSearchTerms$ | async"
      (focus)="setSearchActiveStatus(true)"
      (blur)="blur()"
      (keydown)="focus()"
      (keydown.esc)="blur()"
      (keydown.arrowleft)="selectSuggestedTerm(-1)"
      (keydown.arrowright)="selectSuggestedTerm(-1)"
      (keydown.arrowdown)="preventDefault($event); selectSuggestedTerm(activeIndex + 1)"
      (keydown.arrowup)="preventDefault($event); selectSuggestedTerm(activeIndex - 1)"
      (keydown.enter)="submitSearch(searchInput.value)"
    />

    <!-- Button container -->
    <div
      class="buttons position-absolute top-0 end-0 d-flex align-items-center justify-content-center h-100 p-0 m-0 flex-wrap"
    >
      <!-- Voice Search Button -->
      <button (click)="startVoiceSearch()" class="btn btn-outline me-1" *ishFeature="'voiceSearch'" style="right: 30px">
        <div class="mic-container" [ngClass]="{ recording: isRecording$ | async }">
          <div class="outer-circle"></div>
          <fa-icon
            [icon]="['fas', 'microphone']"
            class="mic-icon"
            [ngClass]="{ 'recording-mic': isRecording$ | async }"
          />
          <div class="inner-circle" [ngClass]="{ recording: isRecording$ | async }"></div>
        </div>
      </button>

      <!-- Reset button (voice enabled) -->
      <ng-container *ishFeature="'voiceSearch'">
        @if (searchInput.value) {
        <button
          class="btn btn-outline me-1"
          type="reset"
          name="reset"
          [title]="'search.searchbox.button.reset.title' | translate"
          style="right: 60px"
          (click)="searchSuggestEmpty(); searchInput.focus()"
        >
          <fa-icon [icon]="['fas', 'times-circle']" />
        </button>
        }
      </ng-container>

      <!-- Reset button (no voice) -->
      <ng-container *ishNotFeature="'voiceSearch'">
        @if (searchInput.value) {
        <button
          class="btn btn-outline me-1"
          type="reset"
          name="reset"
          [title]="'search.searchbox.button.reset.title' | translate"
          style="right: 30px"
          (click)="searchSuggestEmpty(); searchInput.focus()"
        >
          <fa-icon [icon]="['fas', 'times-circle']" />
        </button>
        }
      </ng-container>

      <!-- Search button -->
      <button
        class="btn btn-outline"
        type="submit"
        name="search"
        [title]="'search.searchbox.button.title' | translate"
        (click)="submitSearch(searchInput.value)"
      >
        @if (!configuration?.buttonText) {
        <fa-icon [icon]="['fas', usedIcon]" />
        } @else {
        {{ configuration?.buttonText }}
        }
      </button>
    </div>

    <!-- Suggestion Results -->
    @if ({ products: productSearchResults$ | async, categories: categorySearchResults$ | async, brands:
    brandSearchResults$ | async }; as results) { @if ( (results.products.length || results.categories.length ||
    results.brands.length) && searchInput.value.length > 2 && inputFocused ) {
    <ul class="search-suggest-results overflow-auto">
      @if (results.products.length) {
      <p>Products</p>
      } @for (result of results.products | slice : 0 : configuration?.maxAutoSuggests; track result; let liIndex =
      $index) {
      <li
        [class.active-suggestion]="activeIndex === liIndex"
        (mousedown)="submitSearch(result.term)"
        (mouseenter)="changeActiveIndex(liIndex)"
      >
        <button
          type="button"
          class="search-result"
          [innerHTML]="result.term | titlecase | ishHighlight : (inputSearchTerms$ | async)"
        ></button>
      </li>
      } @if (results.categories.length) {
      <p>Categories</p>
      } @for (result of results.categories; track result; let liIndex = $index) {
      <li
        [class.active-suggestion]="activeIndex === liIndex + results.products.length"
        (mousedown)="submitSearch(result.term)"
        (mouseenter)="changeActiveIndex(liIndex + results.products.length)"
      >
        <button
          type="button"
          class="search-result"
          [innerHTML]="result.term | titlecase | ishHighlight : (inputSearchTerms$ | async)"
        ></button>
      </li>
      } @if (results.brands.length) {
      <p>Brands</p>
      } @for (result of results.brands; track result; let liIndex = $index) {
      <li
        [class.active-suggestion]="activeIndex === liIndex + results.products.length + results.categories.length"
        (mousedown)="submitSearch(result.term)"
        (mouseenter)="changeActiveIndex(liIndex + results.products.length + results.categories.length)"
      >
        <button
          type="button"
          class="search-result"
          [innerHTML]="result.term | titlecase | ishHighlight : (inputSearchTerms$ | async)"
        ></button>
      </li>
      }
    </ul>
    } }
  </div>
</div>
